import styled, { css } from 'styled-components';

import { LoadingAnimation } from 'components/loading-animation';

export const LabelText = styled.span`
  font: ${p => p.theme.token('text-style-form-checkbox')};
  color: ${p => p.theme.token('text-default')};
  cursor: 'pointer';
`;

export const LabelHeader = styled.p`
  font: ${p => p.theme.token('text-style-form-checkbox-header')};
  color: ${p => p.theme.token('text-default')};
  margin: 0;
`;

export const LabelTitle = styled.div`
  font: ${p => p.theme.token('text-style-form-checkbox-header')};
  color: ${p => p.theme.token('text-default')};
  margin: 0;
  font-weight: ${Styles.fontWeight.black};
`;

export const LabelTitleWrapper = styled.div`
  display: flex;
  margin: 0;
  margin-inline-start: 8px;
`;

export const LabelWrapper = styled.div<{ isSelected?: boolean }>`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin: 0;
  margin-inline-start: 8px;
  opacity: ${p => (p.isSelected ? 0.5 : 1)};
`;

export const LabelArrow = styled.div<{ $collapsed?: boolean }>`
  margin-inline-start: auto;
  cursor: pointer;
  ${props =>
    !props.$collapsed &&
    css`
      transform: rotate(90deg);
    `}
`;

export const LinkButton = styled.p`
  font: ${p => p.theme.token('text-link-default')};
  color: ${p => p.theme.token('text-default')};
  text-decoration: underline;
  margin: 0;
  margin-inline-start: auto;
`;

export const AddressList = styled.div`
  margin: 0.5rem 0;
`;

export const AddressWrapper = styled.div`
  margin: 2.5rem 0;
`;

export const AddressTitleWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const LoadingIcon = styled(LoadingAnimation)`
  width: 2rem;
  height: 100%;
`;

export const AddressContainer = styled.label`
  width: 100%;
  padding: 1rem;
  padding-inline-start: 0;
  border: 1px solid ${Styles.color.grey.four};
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-block-start: -1px; /* for overlapping borders */
  border-block-start: 0;
  border-inline-end: 0;
  border-inline-start: 0;
  &:last-child {
    border-block-end: 0;
  }
  justify-content: left;
  border-radius: 0;
`;
